import React from 'react';

const Imprint = () => {
  return (
    <div className="legal-page container" style={{ padding: '100px 20px' }}>
      <div className="section-title text-center">
        <h1>Imprint</h1>
      </div>

      <p>
        <strong>Mahanc UG (haftungsbeschränkt)</strong>
      </p>
      <p>
        Nordendstr. 15
        <br />
        82256 Fürstenfeldbruck
        <br />
        Germany
      </p>

      <h3>Represented By:</h3>
      <p>Yunes Mahan, Managing Director</p>

      <h3>Contact Information:</h3>
      <p>
        Email: contact@mahanc.com
        <br />
        Phone: +49 176 444967
      </p>

      <h3>Website:</h3>
      <p>
        <a href="https://mahanc.com" target="_blank" rel="noopener noreferrer">
          mahanc.com
        </a>
      </p>

      <h3>Responsible for Content (according to § 55 Abs. 2 RStV):</h3>
      <p>Yunes Mahan (Address as above)</p>

      <h3>Legal Form:</h3>
      <p>Unternehmergesellschaft (haftungsbeschränkt)</p>
    </div>
  );
};

export default Imprint;
